// extracted by mini-css-extract-plugin
module.exports = {"interface":"CheckAllInterface_interface__1RmY2"};